var _rect, _path, _g, _rect2, _path2, _path3, _rect3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12801_148167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12801_148167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2 12C22.2 6.36669 17.6333 1.8 12 1.8C6.36669 1.8 1.8 6.36669 1.8 12C1.8 17.6333 6.36669 22.2 12 22.2C17.6333 22.2 22.2 17.6333 22.2 12ZM24 12C24 5.37258 18.6274 -8.1423e-07 12 -5.24537e-07C5.37258 -2.34843e-07 -8.1423e-07 5.37258 -5.24536e-07 12C-2.34843e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#46EE6A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12801_148167)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12801_148167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V36H0V0Z",
    fill: "#2F80ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_12801_148167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12H36V24H0V12Z",
    fill: "#2F80ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_12801_148167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 -12H24V24H12V-12Z",
    fill: "#2F80ED"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5994 8.3999L8.39941 15.5999",
    stroke: "#777F88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39941 8.3999L15.5994 15.5999",
    stroke: "#777F88",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8002 9L10.2002 15.6L7.2002 12.6",
    stroke: "#177AF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12801_148167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12801_148167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_12801_148167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_12801_148167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5a3c4de7b18ddfd7a40a0ef07ecc102e.svg";
export { ForwardRef as ReactComponent };